import { useParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { toast } from "react-toastify";
import { env } from "../../constants/env";
import classes from "./DownloadReportPage.module.css";
import CommonButton from "../ui/CommonButton/CommonButton";

const DownloadReportPage = () => {
  const { labId, accreditationName } = useParams();
  const { token } = useAuth();

  if (!["SADCAS F134-A", "SADCAS F134-B"].includes(accreditationName)) {
    return <p>Invalid accreditation type.</p>;
  }

  const downloadReport = async () => {
    try {
      const response = await fetch(
        `${env.kataApiUrl}/api/accreditation/${accreditationName}/${labId}/download-report`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );



      if (!response.ok) throw new Error("Failed to download report");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${accreditationName.replace(/\s+/g, "_")}_${labId}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (err) {
      toast.error(err.message || "Download failed");
    }
  };

  return (
    <div className={classes.wrapper}>
      <h2>Download Report</h2>
      <p>{accreditationName}</p>
      <div className="d-flex justify-content-center mt-4">
        <CommonButton title={<span>Download Report</span>} onClick={downloadReport} />
      </div>
    </div>
  );
};

export default DownloadReportPage;